"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _HotelExperienceExpanded["default"];
  }
});
var _HotelExperienceExpanded = _interopRequireDefault(require("./HotelExperienceExpanded"));